import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase'

const CarOwnerIcon = ({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = 1,
  ...props
}) => {
  return (
    <IconBase viewBox='0 0 19 20' {...props}>
      <Path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        fill={fill}
        d='M16.101 18.441H2.9A1.887 1.887 0 0 1 1 16.565V6.247c0-1.036.85-1.876
         1.899-1.876H16.1c1.05 0 1.899.84 1.899 1.876v10.318c0 1.037-.85 1.876-1.899 1.876Z'
        clipRule='evenodd'
      />
      <Path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        fill={fill}
        d='M9.502 7.188c1.311 0 2.373 1.05 2.373 2.345 0 1.295-1.062
         2.345-2.373 2.345-1.31 0-2.373-1.05-2.373-2.345 0-1.296 1.062-2.345 2.373-2.345Z'
        clipRule='evenodd'
      />
      <Path
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        fill={fill}
        d='M13.77 15.622a2.233 2.233 0 0 0-.564-.812v0a2.262 2.262
         0 0 0-1.532-.595H7.323c-.57 0-1.115.213-1.533.595v0c-.246.226-.44
         .503-.563.812M2.648 4.373v-.938c0-1.037.85-1.876 1.899-1.876h9.906c1.049 0 1.899.84 1.899 1.876v.938'
      />
    </IconBase>
  )
}

CarOwnerIcon.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.number,
}

export default CarOwnerIcon
